import axios from "axios";
import { API_BE4FE_URL } from "../config";
import { RootState } from "../reducers/store";
import { createHttpHeaderWithAuthorization } from "../services/http-header";

export const GET_PACKAGE_START = "GET_PACKAGE_START";
export const GET_PACKAGE_SUCCESS = "GET_PACKAGE_SUCCESS";
export const GET_PACKAGE_ERROR = "GET_PACKAGE_ERROR";
export const GET_METERING_PACKAGE_START = "GET_METERING_PACKAGE_START";
export const GET_METERING_PACKAGE_SUCCESS = "GET_METERING_PACKAGE_SUCCESS";
export const GET_METERING_PACKAGE_ERROR = "GET_METERING_PACKAGE_ERROR";

export const getUserPackage = () => {
    return (dispatch: any, getState: () => RootState) => {
        return new Promise(function (resolve, reject) {
            const main = getState().main;
            const itemId = main.companyUuid || main.accountantUuid;
            dispatch({ type: "GET_PACKAGE_START" });
            axios
                .get(
                    `${API_BE4FE_URL}/packages?itemId=${itemId}&activeOnly=true`,
                    {
                        headers: dispatch(
                            createHttpHeaderWithAuthorization(true),
                        ),
                    },
                )
                .then((result) => {
                    dispatch({
                        type: "GET_PACKAGE_SUCCESS",
                        payload: { ...result.data },
                    });
                    resolve(result.data);
                })
                .catch((e) => {
                    dispatch({ type: "GET_PACKAGE_ERROR" });
                    reject(e);
                });
        });
    };
};

export const getMeteringPackage = () => {
    return (dispatch: any, getState: () => RootState) => {
        return new Promise(function (resolve, reject) {
            const main = getState().main;
            const itemId = main.companyUuid || main.accountantUuid;
            dispatch({ type: "GET_METERING_PACKAGE_START" });
            axios
                .get(`${API_BE4FE_URL}/metering-packages?itemId=${itemId}`, {
                    headers: dispatch(createHttpHeaderWithAuthorization(true)),
                })
                .then((result) => {
                    dispatch({
                        type: "GET_METERING_PACKAGE_SUCCESS",
                        payload: {
                            expireDate:
                                result.data?.find(
                                    (x: any) =>
                                        x?.family === "BUSINESS_INFORMATION",
                                )?.expireDate || null,
                        },
                    });
                    resolve(result.data);
                })
                .catch((e) => {
                    dispatch({ type: "GET_METERING_PACKAGE_ERROR" });
                    reject(e);
                });
        });
    };
};
